/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconClose: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M773.802667 304.469333l-54.314667-54.314666a4.266667 4.266667 0 0 0-6.016 0L520.533333 443.136a4.266667 4.266667 0 0 1-6.016 0L321.493333 250.197333a4.266667 4.266667 0 0 0-6.016 0L261.12 304.469333a4.266667 4.266667 0 0 0 0 6.016l192.981333 192.981334a4.266667 4.266667 0 0 1 0 6.016L261.12 702.464a4.266667 4.266667 0 0 0 0 6.016l54.314667 54.314667a4.266667 4.266667 0 0 0 6.016 0l192.981333-192.981334a4.266667 4.266667 0 0 1 6.016 0l192.981333 192.981334a4.266667 4.266667 0 0 0 6.016 0l54.314667-54.314667a4.266667 4.266667 0 0 0 0-6.016l-192.981333-192.981333a4.266667 4.266667 0 0 1 0-6.016l192.981333-192.981334a4.266667 4.266667 0 0 0 0-6.016z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </svg>
  );
};

IconClose.defaultProps = {
  size: 18,
};

export default IconClose;
